<template>
  <v-app :class="{ 'locale-th': $i18n.locale === 'th' }">
    <NavBar
      v-if="
        $route.path == '/Main' ||
        $route.path == '/MainMenu' ||
        $route.path == '/ManagePreRegister' ||
        $route.path == '/ManageUser' ||
        $route.path == '/ManageRole' ||
        $route.path == '/MyQR' ||
        $route.path == '/CallLift' ||
        $route.path == '/ParkingInformation' ||
        $route.path == '/PreRegister' ||
        $route.path == '/Redemption' ||
        $route.path == '/TerminalStamp' ||
        $route.path == '/ManageQuotaRate' ||
        $route.path == '/TerminalStampMain' ||
        $route.path == '/TerminalStampRabbit'
      "
    />
    <NavBarProjectSite v-if="$route.path == '/ProjectSite'" />
    <v-content>
      <div>
        <router-view></router-view>
      </div>
      <!-- <div :id="$route.path === '/ProjectSite' ? 'grad' : null">
        <router-view></router-view>
      </div> -->
    </v-content>
    <Footer />
  </v-app>
</template>

<script>
import NavBar from "./components/NavBar";
import Footer from "./components/Footer";
import NavBarProjectSite from "./components/NavBarProjectSite";
export default {
  name: "App",
  components: {
    NavBar,
    Footer,
    NavBarProjectSite,
  },
  
  mounted() {
    this.checkInterval = setInterval(() => {
      if (this.$terminalSession.isActive()) {
        this.$terminalSession.ensureFresh().then((token) => {
          if (token) return this.$store.dispatch("CheckToken", { token });
        }).catch(() => {});
        return;
      }
      const token = this.$cookies.get("Token");
      if (token) {
        this.$store.dispatch("CheckToken", { token }).catch(() => {});
      }
    }, 60 * 1000);
  },

  beforeDestroy() {
    if (this.checkInterval) clearInterval(this.checkInterval);
  },
};
</script>

<style>
/* #grad {
    height: 600px;
    background: #78A3D4;
    background: -webkit-linear-gradient(#78A3D4, #FFF); 
    background: -o-linear-gradient(#78A3D4, #FFF);
    background: -moz-linear-gradient(#78A3D4, #FFF);
    background: linear-gradient(#78A3D4, #FFF);
} */

@font-face {
  font-family: "English";
  src: local("English"), url(./assets/Font/Kanit-Regular.ttf);
}

@font-face {
  font-family: "Kanit";
  font-style: normal;
  font-weight: 400;
  font-display: swap;
  src: url(./assets/Font/Kanit-Regular.ttf) format("truetype");
}

.locale-th *:not(.v-icon):not(.material-icons):not(.mdi):not(.app-header):not(.app-header *):not(.app-footer):not(.app-footer *) {
  font-family: "Kanit", sans-serif !important;
}
/* .v-main__wrap {
  background-color: white;
  width: 100%;
  height: 100%;
} */

.v-content__wrap {
  background-color: white;
  width: 100%;
  height: 100%;
}

@media only screen and (max-width: 959px) {
  /* .v-main__wrap {
    background-color: white;
    width: 80%;
  } */
  .v-content__wrap {
    background-color: white;
    width: 80%;
  }
}
* {
  font-family: "English";
}

#app {
  color: #444444;
}

::-webkit-scrollbar {
  display: none;
}
</style>
